import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  faLinkedinIn,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import { GlobalService } from "../../shared/services/global.service";
import { LandingPageService } from "../../shared/services/landing-page.service";

import { HeroShellComponent } from "../../shared/components/sections/hero-shell/hero-shell.component";
import { VideoPlayerComponent } from "../../shared/components/sections/video-player/video-player.component";
import {
  AudiencePickerSectionComponent,
  AudienceCardConfig,
} from "../../shared/components/sections/audience-picker-section/audience-picker-section.component";
import { HomeWhatWeDoSectionComponent } from "../../shared/components/sections/home-what-we-do-section/home-what-we-do-section.component";
import { HomeProjectsSectionComponent } from "../../shared/components/sections/home-projects-section/home-projects-section.component";
import { HomeVideosSectionComponent } from "../../shared/components/sections/home-videos-section/home-videos-section.component";
import { HomeEventsSectionComponent } from "../../shared/components/sections/home-events-section/home-events-section.component";
import { HomeInstagramSectionComponent } from "../../shared/components/sections/home-instagram-section/home-instagram-section.component";
import { HomeBlogSectionComponent } from "../../shared/components/sections/home-blog-section/home-blog-section.component";
import { HomeStatisticsSectionComponent } from "../../shared/components/sections/home-statistics-section/home-statistics-section.component";
import { HomePartnersSectionComponent } from "../../shared/components/sections/home-partners-section/home-partners-section.component";
import { HomeSchoolsSectionComponent } from "../../shared/components/sections/home-schools-section/home-schools-section.component";
import { HomeNewsletterSectionComponent } from "../../shared/components/sections/home-newsletter-section/home-newsletter-section.component";

@Component({
  selector: "app-page-home",
  templateUrl: "./page-home.component.html",
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    HeroShellComponent,
    VideoPlayerComponent,
    AudiencePickerSectionComponent,
    HomeWhatWeDoSectionComponent,
    HomeProjectsSectionComponent,
    HomeVideosSectionComponent,
    HomeEventsSectionComponent,
    HomeInstagramSectionComponent,
    HomeBlogSectionComponent,
    HomeStatisticsSectionComponent,
    HomePartnersSectionComponent,
    HomeSchoolsSectionComponent,
    HomeNewsletterSectionComponent,
  ],
  standalone: true,
})
export class PageHomeComponent {
  readonly global = inject(GlobalService);
  readonly landing = inject(LandingPageService);

  heroConfig = {
    videoUrl: "https://youtu.be/4KQlR5SG0HQ",
    backgroundImage: "assets/img/bg/laptop-typing-bg.png",
  };

  socials = [
    {
      href: "https://www.linkedin.com/company/5316028/",
      icon: faLinkedinIn,
      label: "LinkedIn",
    },
    {
      href: "https://www.instagram.com/meettheyoungsters/",
      icon: faInstagram,
      label: "Instagram",
    },
    {
      href: "https://www.youtube.com/channel/UC_cWwKbrVnPIvWSVkL-S6Sg",
      icon: faYoutube,
      label: "YouTube",
    },
  ];

  audienceCards: AudienceCardConfig[] = [
    {
      icon: "backpack",
      titleKey: "Pupil",
      bodyKey:
        "Discover careers, companies and training. Get a first look at the labour market and start building your future early.",
      link: "/pupil",
    },
    {
      icon: "graduation-cap",
      titleKey: "Student",
      bodyKey:
        "For students who want to apply their knowledge, gain experience and expand their network during their studies.",
      link: "/student",
    },
    {
      icon: "rocket",
      titleKey: "Young Professional",
      bodyKey:
        "For recent graduates and starters (0–3 years of experience) who want to launch their career and gain valuable experience at companies.",
      link: "/young-professional",
    },
    {
      icon: "briefcase",
      titleKey: "Professional",
      bodyKey:
        "For experienced employees (3+ years of experience) who want to develop their expertise and explore new career opportunities.",
      link: "/professional",
    },
    {
      icon: "globe",
      titleKey: "International",
      bodyKey:
        "Find opportunities in the Euregio as an international. Discover companies, guidance and possibilities to work here.",
      link: "/international",
    },
    {
      icon: "chalkboard-user",
      titleKey: "Teacher",
      bodyKey:
        "Discover how you can guide and support your pupils with the tools and projects of Meet the Youngsters.",
      link: "/teacher",
    },
    {
      icon: "building",
      titleKey: "Company",
      bodyKey:
        "For organisations who want to attract young talent, support them sustainably and strengthen their employer branding at the same time.",
      link: "/company",
    },
  ];
}
